<template>
  <div class="container">
    <h4 class="text-center pt-4" style="letter-spacing: 3px">
      {{ welcomTitle }}
    </h4>
    <p class="pt-2">{{ info }}</p>
    <p>{{ purpose }}</p>
    <ol>
      <li v-for="(projName, index) in projects" :key="index">
        {{ projName.name }}
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      welcomTitle: "ჩვენს შესახებ",
      info:
        "წიკლაურთა საგვარეულო ერთობა დაილოცა პატრიარქის მიერ 2010 წლის 23 მაისს. ხატმწერი მამუკა გელაშვილის მიერ დაიწერა ხატი, ივერიის ყოვლადწმინდა ღვთისმშობელი. 2012 წლის 23 იანვარს დაფუძნდა წიკლაურთა საგვარეულო ერთობა. მოგვენიჭა არასამეწარმეო (არაკომერციული) იურიდიული პირის სტატუსი რეგისტრაციის ნომრით #404926586.",
      purpose:
        "წიკლაურთა საგვარეულო ერთობის მიზანია ერთობლივი სიკეთის კეთების გზით, საქართველოში სიყვარულის და ურთიერთპატივისცემის გაღრმავება. ამისთვის საგვარეულო ერთობა ახორციელებს შემდეგ პროექტებს.",
      projects: [
        { name: "ივერიის ყოვლადწმინდა ღვთისმშობლის ხატის გადაბრძანება" },
        { name: "დავეხმაროთ ერთმანეთს" },
        { name: "კინო და თეატრი ბავშვებისთვის" },
        { name: "თავისუფალი დარბაზი ხელოვანს" },
        { name: "დარგე ხე წიკლაურებთან ერთად" },
        { name: "ბავშვები გასართობ ცენტრში" },
        { name: "მოაწესრიგე სალოცავი  წიკლაურებთან  ერთად" },
      ],
    };
  },
};
</script>